(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 749;
  var RESUME_DELAY_MS = 4000; // Pause auto-cycle this long after a manual tap

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function initSection(wrapper) {
    var desktopItems = wrapper.querySelectorAll('.chn-item');
    var desktopSlides = wrapper.querySelectorAll('.chn-image-slide');
    var mobileItems = wrapper.querySelectorAll('.chn-mobile-list__item');
    var mobileImages = wrapper.querySelectorAll('.chn-mobile-image');
    var mobileLinks = wrapper.querySelectorAll('.chn-mobile-list__link');
    var mobileImageLink = wrapper.querySelector('.chn-mobile-image-link');

    if (!desktopItems.length && !mobileItems.length) return;

    var totalBlocks = Math.max(desktopItems.length, mobileItems.length);
    var activeIndex = 0;
    var cycleTimer = null;
    var resumeTimer = null;
    var navigateTimer = null;

    var intervalAttr = parseInt(wrapper.getAttribute('data-mobile-interval'), 10);
    var interval = !isNaN(intervalAttr) && intervalAttr > 0 ? intervalAttr : 2500;

    var tapDelayAttr = parseInt(wrapper.getAttribute('data-mobile-tap-delay'), 10);
    var tapNavigateDelay = !isNaN(tapDelayAttr) && tapDelayAttr >= 0 ? tapDelayAttr : 400;

    function activate(index) {
      activeIndex = index;

      desktopItems.forEach(function (el, i) {
        el.classList.toggle('chn-item--active', i === index);
      });
      desktopSlides.forEach(function (el, i) {
        el.classList.toggle('chn-image-slide--active', i === index);
      });
      mobileItems.forEach(function (el, i) {
        el.classList.toggle('chn-mobile-list__item--active', i === index);
      });
      mobileImages.forEach(function (el, i) {
        el.classList.toggle('chn-mobile-image--active', i === index);
      });

      // Keep the image's wrapping <a> pointed at the active block's link
      if (mobileImageLink && mobileLinks[index]) {
        var href = mobileLinks[index].getAttribute('href') || '#';
        mobileImageLink.setAttribute('href', href);
      }
    }

    function next() {
      var nextIndex = (activeIndex + 1) % totalBlocks;
      activate(nextIndex);
    }

    function startCycle() {
      stopCycle();
      if (totalBlocks <= 1) return;
      if (!isMobile()) return;
      cycleTimer = setInterval(next, interval);
    }

    function stopCycle() {
      if (cycleTimer) {
        clearInterval(cycleTimer);
        cycleTimer = null;
      }
    }

    function cancelPendingNavigate() {
      if (navigateTimer) {
        clearTimeout(navigateTimer);
        navigateTimer = null;
      }
    }

    function pauseAndResume() {
      stopCycle();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        startCycle();
      }, RESUME_DELAY_MS);
    }

    // Initial state
    activate(0);

    // ── Desktop: hover to activate ──
    desktopItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var idx = parseInt(item.getAttribute('data-block-index'), 10);
        if (!isNaN(idx)) activate(idx);
      });
    });

    // ── Mobile: tap behavior on label links ──
    // - Tap on already-active label: navigate immediately (native anchor)
    // - Tap on non-active label: prevent default, activate it, then auto-navigate after the configured delay
    mobileLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var idx = parseInt(link.getAttribute('data-block-index'), 10);
        if (isNaN(idx)) return;

        if (idx !== activeIndex) {
          e.preventDefault();
          var href = link.getAttribute('href') || '#';

          // Cancel any prior pending navigation (e.g. user tapped a different label mid-delay)
          cancelPendingNavigate();

          activate(idx);
          stopCycle();

          if (tapNavigateDelay <= 0) {
            window.location.href = href;
            return;
          }

          navigateTimer = setTimeout(function () {
            window.location.href = href;
          }, tapNavigateDelay);
        }
        // else: allow default navigation
      });
    });

    // ── Mobile image tap: always navigates to current active link ──
    // (href is kept in sync by activate(); native anchor handles navigation)

    // ── Start auto-cycle on mobile ──
    startCycle();

    // ── Re-evaluate on resize (mobile <-> desktop) ──
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) {
          startCycle();
        } else {
          cancelPendingNavigate();
          stopCycle();
        }
      }, 150);
    });

    // ── Pause cycle when tab is hidden ──
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopCycle();
      } else if (isMobile()) {
        startCycle();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.chn-wrapper').forEach(function (wrapper) {
      initSection(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var wrapper = e.target.querySelector('.chn-wrapper');
    if (wrapper) initSection(wrapper);
  });

})();